// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O4t5y7yVqOYXmgxHHFTA {
    font-family: Raleway, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0.005em;
    color: rgba(0, 0, 0, 0.8);

}


.OIGBD4nInXfkpNs9rrxK {
    padding: 16px;
    background-color: white;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
    .B_Z8xsNlYvCO9AprVF2c {
        margin-top: 0;
    }

    .OIGBD4nInXfkpNs9rrxK {
        scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */
        scrollbar-width: thin;
    }

    .OIGBD4nInXfkpNs9rrxK::-webkit-scrollbar {
        width: 5px;  /* for vertical scrollbars */
    }

    .OIGBD4nInXfkpNs9rrxK::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }

    .O4t5y7yVqOYXmgxHHFTA {
        font-size: 20px;
        margin-top: 0;
        margin-bottom: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Confirmation/ConfirmationForm/ConfirmationForm.module.css"],"names":[],"mappings":"AAGA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;;AAE7B;;;AAGA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,+CAA+C,EAAE,0BAA0B;QAC3E,qBAAqB;IACzB;;IAEA;QACI,UAAU,GAAG,4BAA4B;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;AACJ","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n.title {\n    font-family: Raleway, sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 24px;\n    line-height: 28px;\n    letter-spacing: 0.005em;\n    color: rgba(0, 0, 0, 0.8);\n\n}\n\n\n.form {\n    padding: 16px;\n    background-color: white;\n}\n\n@media screen and (max-width: tablet) {\n    .confirmation {\n        margin-top: 0;\n    }\n\n    .form {\n        scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */\n        scrollbar-width: thin;\n    }\n\n    .form::-webkit-scrollbar {\n        width: 5px;  /* for vertical scrollbars */\n    }\n\n    .form::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.1);\n        border-radius: 5px;\n    }\n\n    .title {\n        font-size: 20px;\n        margin-top: 0;\n        margin-bottom: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"title": `O4t5y7yVqOYXmgxHHFTA`,
	"form": `OIGBD4nInXfkpNs9rrxK`,
	"confirmation": `B_Z8xsNlYvCO9AprVF2c`
};
export default ___CSS_LOADER_EXPORT___;
